export default {"src":"/_next/static/media/speak-no-evil-own.21f6b8e3.svg","height":100,"width":100};